(() => {
  const initialized = new WeakSet();

  function init() {
    document.querySelectorAll('[data-emz-product-link]').forEach(widget => {
      const section = widget.closest('[data-section-type="product"]');
      if (!section || section.dataset.modal === 'true' || initialized.has(widget)) return;
      const button = widget.querySelector('[data-copy-product-link]');
      const status = widget.querySelector('[data-copy-status]');
      const fallback = widget.querySelector('[data-copy-fallback]');
      const input = fallback && fallback.querySelector('input');
      if (!button || !status || !fallback || !input) return;
      let base;
      try {
        base = new URL(widget.dataset.productUrl, window.location.origin);
        if (base.origin !== window.location.origin || !/^https?:$/.test(base.protocol)) return;
        const productPath = base.pathname.match(/\/products\/([^/]+)\/?$/);
        if (!productPath || decodeURIComponent(productPath[1]) !== section.dataset.productHandle) return;
        base.search = '';
        base.hash = '';
      } catch (_) {
        return;
      }
      initialized.add(widget);
      widget.hidden = false;
      let revision = 0;
      let copying = false;
      section.addEventListener('change', () => {
        revision++;
        status.textContent = '';
        fallback.hidden = true;
      });
      button.addEventListener('click', async () => {
        if (copying) return;
        const requestRevision = revision;
        const url = new URL(base.href);
        const variant = section.querySelector('.product-single__form [name="id"]');
        if (variant && /^\d+$/.test(variant.value)) url.searchParams.set('variant', variant.value);
        status.textContent = '';
        fallback.hidden = true;
        copying = true;
        button.setAttribute('aria-busy', 'true');
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url.href);
          if (widget.isConnected && requestRevision === revision) status.textContent = widget.dataset.copied;
        } catch (_) {
          if (!widget.isConnected || requestRevision !== revision) return;
          input.value = url.href;
          fallback.hidden = false;
          status.textContent = widget.dataset.copyFallback;
          if (document.activeElement === button) {
            input.focus();
            input.select();
          }
        } finally {
          copying = false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
